import { render, staticRenderFns } from "./Resources.vue?vue&type=template&id=6999a202&scoped=true"
import script from "./Resources.vue?vue&type=script&lang=ts"
export * from "./Resources.vue?vue&type=script&lang=ts"
import style0 from "./Resources.vue?vue&type=style&index=0&id=6999a202&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6999a202",
  null
  
)

export default component.exports